import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-savedialog',
  templateUrl: './savedialog.component.html',
  styleUrls: ['./savedialog.component.scss']
})
export class SavedialogComponent {
  constructor(private dialog:MatDialog){}
  openokdialog()
  {
   this.dialog.getDialogById('save')?.close(true)
  }
  close()
  {
     this.dialog.getDialogById('save')?.close(false)
  }
}